import { Required } from "utility-types"
import {
	TTravelActivityDatewisePricesInputFieldValue,
	TValidTravelActivityDatewisePricesInputFieldValue,
} from "./TravelActivityDatewisePricesInputField"
import {
	TTravelActivityDuration,
	TTravelActivityTicketType,
} from "../TravelActivities"
import { createDuration } from "@sembark-travel/datetime-utils"
import { extractLocationString } from "../TransportServices/utils"

export function getValidTravelActivityData(
	c: TTravelActivityDatewisePricesInputFieldValue
): TValidTravelActivityDatewisePricesInputFieldValue | undefined {
	const {
		dates,
		activity,
		ticket_tourist_configurations,
		pick_up_location,
		drop_location,
		...others
	} = c
	if (!dates?.length || !activity || !ticket_tourist_configurations?.length) {
		return undefined
	}
	const validConfigurations = (ticket_tourist_configurations || []).filter(
		(c): c is Required<typeof c, "quantity" | "configuration"> =>
			Boolean(c.quantity && c.configuration)
	)
	if (!validConfigurations?.length) return undefined
	return {
		...others,
		dates,
		activity,
		pick_up_location: extractLocationString(pick_up_location) || undefined,
		drop_location: extractLocationString(drop_location) || undefined,
		ticket_tourist_configurations: validConfigurations,
	}
}

export function getActivityDurationSlotAndOptions(
	ticket_type: TTravelActivityTicketType | undefined,
	duration: string | undefined,
	slot: string | undefined
): {
	durationOption: TTravelActivityDuration | undefined
	activitySlot: string | undefined
	activitySlotsOptions: Array<string> | undefined
} {
	let durationOption: TTravelActivityDuration | undefined =
		ticket_type?.durations?.find((d) => d.iso && d.iso === duration)

	let activitySlot: string | undefined = slot
	let activitySlotsOptions: Array<string> | undefined = undefined

	if (duration && !durationOption) {
		const parseDuration = createDuration(duration)
		durationOption = {
			name: parseDuration.asMinutes() + " Mins",
			iso: duration,
		}
	}

	if (durationOption && !slot && durationOption.slots?.length === 1) {
		activitySlot = durationOption.slots[0]
	}

	if (slot && !durationOption) {
		activitySlotsOptions = [slot]
	} else {
		if (durationOption && durationOption?.slots?.length) {
			activitySlotsOptions = durationOption.slots
		}

		if (!slot && ticket_type?.durations?.at(0)?.slots?.length) {
			activitySlotsOptions = ticket_type?.durations?.at(0)?.slots
		}
	}

	return {
		durationOption,
		activitySlot,
		activitySlotsOptions,
	}
}
